<script lang="ts">
  // Abschnitt „Gedächtnis" im Baum des Bereichs Claude (docs/gedaechtnis.md):
  // die jüngsten Zugriffe auf die Datenbank, wie „Commits" (Tim 21.10.2026:
  // „Baue hier unten wieder das Gedächtnis mit einer kleinen Übersicht wie
  // bei Änderungen und Commits ein"). Lupe = gelesen (gesucht, gelesen,
  // erinnert), Stift = geschrieben (eingelesen, Bedeutung gerechnet,
  // zusammengefasst). Ohne Inhalt -- wonach gesucht wurde, steht auf der
  // Seite hinter der PIN. Ein Klick öffnet sie als Vorschau.
  import Icon from "../Icon.svelte";
  import { claudeChat } from "../claude-summary.svelte";
  import { zugriffZeile } from "../gedaechtnis/gedaechtnis";
  import { getGedaechtnis, startGedaechtnis } from "../gedaechtnis-summary.svelte";
  import { t } from "../i18n.svelte";
  import { oeffnePfad } from "../shell/route-sync.svelte";
  import { wannKurz } from "./claude";

  startGedaechtnis();
  const letzte = $derived(getGedaechtnis()?.zugriffe?.letzte ?? []);
  let jetzt = $state(new Date());
  $effect(() => {
    const iv = setInterval(() => (jetzt = new Date()), 30_000);
    return () => clearInterval(iv);
  });
  const titel = (id: string) => claudeChat(id)?.titel;
  const pfad = "/claude/gedaechtnis";
</script>

<div class="grid pb-2">
  {#each letzte as z (z.id)}
    {@const text = zugriffZeile(z, titel)}
    <button
      type="button"
      class="zeile"
      data-zeile
      title={text}
      onclick={() => oeffnePfad(pfad, { vorschau: true })}
      ondblclick={() => oeffnePfad(pfad)}
    >
      <span class="symbol" class:schreiben={z.art === "schreiben"}><Icon name={z.art === "schreiben" ? "pencil" : "search"} size={12} /></span>
      <span class="truncate">{text}</span>
      <span class="tail tabular-nums">{wannKurz(z.zeit, jetzt)}</span>
    </button>
  {:else}
    <p class="text-fg-subtle t-meta px-3 py-1" data-zeile>{t("gedaechtnis.baum.still", "Noch kein Zugriff.")}</p>
  {/each}
</div>

<style>
  /* Wie eine Zeile in „Commits" (BaumCommits.svelte). */
  .zeile {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
    padding: 0.2rem 0.75rem 0.2rem 1.25rem;
    margin: 1px 0.35rem 1px 0;
    font-size: 0.84rem;
    color: var(--fg);
    text-align: left;
    border-radius: 0.4rem;
  }
  .zeile:hover {
    background: var(--bg-elev);
  }
  .symbol {
    width: 0.8rem;
    flex: none;
    display: grid;
    place-items: center;
    color: var(--fg-subtle);
  }
  .tail {
    margin-left: auto;
    padding-left: 0.4rem;
    font-size: 0.74rem;
    color: var(--fg-subtle);
    white-space: nowrap;
  }
</style>
